import React from "react";
import { Result } from "antd";
import { useNavigate } from "react-router-dom";
import Button from "../../components/generic/Button";
import { ROUTES } from "../../constant/routes";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100dvh",
        background: "#f0f2f5",
      }}
    >
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => navigate(ROUTES.DASHBOARD)}>
            Back Home
          </Button>
        }
        style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
          maxWidth: 600,
          width: "100%",
        }}
      />
    </div>
  );
};

export default NotFound;
